import axios from 'axios';

export const uploadFileToS3Bucket = async (signedUploadUrl, file) => {
  const path = signedUploadUrl;
  const options = {
    headers: { 'Content-Type': file.type }
  };

  return axios.put(path, file, options);
};
